export default "__VITE_ASSET__DfJtj2Rm__"